import React from "react";
import { ROOT } from "../data-hooks";
import styles from "../statics/styles/image-viewer.rtlignore-scss";
const ImageContainer = (props) => {
  const { type, children } = props;
  const onContextMenu = props.disableDownload === true ? (e) => e.preventDefault() : void 0;
  const hasOnClick = "onClick" in props;
  const onClick = hasOnClick ? props.onClick : void 0;
  const onKeyDown = onClick ? (e) => {
    if (e.key === "Enter" || e.key === " ") {
      onClick(e);
    }
  } : void 0;
  const interactions = {
    onClick,
    onKeyDown,
    onContextMenu
  };
  const role = hasOnClick || (type === "anchor" || type === "link" || type === "regular") && !!onContextMenu ? "button" : void 0;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...role === "button" ? interactions : {},
      "data-hook": ROOT,
      className: styles.imageContainer
    },
    children
  );
};
export {
  ImageContainer
};
//# sourceMappingURL=image-container.js.map
